// Graficul unei monede, deschis pe tot ecranul din grilă („Развернуть").

import { el } from '../core/util.js';
import { icon } from './icons.js';
import { ChartPanel } from './chart-panel.js';

export function openChartModal({ symbol, exchange, market, tf }) {
  let panel = null;

  const close = () => {
    panel?.destroy();
    overlay.remove();
    window.removeEventListener('keydown', escape);
  };

  const escape = (event) => { if (event.key === 'Escape') close(); };

  const holder = el('div', { class: 'chart-modal-body' });
  const overlay = el('div', {
    class: 'chart-modal-overlay',
    onclick: (event) => { if (event.target === overlay) close(); },
  }, [
    el('div', { class: 'chart-modal' }, [
      el('button', { class: 'chart-modal-close', title: 'Закрыть (Esc)', onclick: close }, [icon('close', 18)]),
      holder,
    ]),
  ]);

  document.body.append(overlay);
  window.addEventListener('keydown', escape);

  panel = new ChartPanel({ symbol, exchange, market, tf }).mount(holder);
  return close;
}
